import { render, staticRenderFns } from "./invoiceHistory.vue?vue&type=template&id=84d7fc28&scoped=true&"
import script from "./invoiceHistory.vue?vue&type=script&lang=js&"
export * from "./invoiceHistory.vue?vue&type=script&lang=js&"
import style0 from "./invoiceHistory.vue?vue&type=style&index=0&id=84d7fc28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d7fc28",
  null
  
)

export default component.exports